import React, {useEffect, useRef} from "react";
import {DayPicker} from 'react-day-picker'
import {eachWeekendOfInterval} from "date-fns";
import fr from 'date-fns/locale/fr'
import axios from 'axios'
import close from '../../assets/close.svg'

const DayPicking = ({selected, setSelected, setShowDate}) => {
    let disabledDays = [];
    let holidays;

    let newHolidays = []
    let today = new Date()

    const weekend = eachWeekendOfInterval({
        start: today,
        end: new Date(2028, 8, 30)
    })

    useEffect(() => {
        axios.get('https://calendrier.api.gouv.fr/jours-feries/metropole.json')
            .then(r => {
                holidays = r.data;
                for (let i in holidays) {
                    let key = i;
                    holidays = new Date(key)
                    newHolidays.push(holidays)
                    holidays = newHolidays.concat(weekend)
                    disabledDays = holidays
                    // console.log(disabledDays)
                }
            })
    }, [])

    return (
        <div className={"day picker"}>
            <img className={"close"} src={close} onClick={() => {
                setShowDate(false);
                console.log(setShowDate)
            }}/>
            <DayPicker
                mode={"single"}
                locale={fr}
                selected={selected}
                onSelect={setSelected}
                fromDate={today}
                disabled={newHolidays}
                hidden={weekend}
                onDayClick={() => setShowDate(false)}
                onDayBlur={() => setShowDate(false)}
            />
        </div>
    );
};

export default DayPicking;